import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const thumbnailsWithBlurSchema = Joi.object({
  image: mediaUrlSchema,
  blur: mediaUrlSchema,
  desktop: Joi.string().allow('', null),
  tablet: Joi.string().allow('', null),
  mobile: Joi.string().allow('', null)
}).unknown(true);
export default thumbnailsWithBlurSchema;